<template lang="html">
  <div class="companyInfo">
    <div
      v-if="isEmpty(company_info.name)"
      class="companyInfo__item companyName"
    >
      <div class="item__title">
        <span>会社名</span>
      </div>
      <div class="item__content">
        <span>
          {{ company_info.name }}
        </span>
      </div>
    </div>
    <div
      v-if="isEmpty(company_info.established_year)"
      class="companyInfo__item establishIn"
    >
      <div class="item__title">
        <span>設⽴年度</span>
      </div>
      <div class="item__content">
        <span> {{ established_year }} </span>
      </div>
    </div>
    <div
      v-if="isEmpty(representativeName)"
      class="companyInfo__item representativeName"
    >
      <div class="item__title">
        <span>代表者名</span>
      </div>
      <div class="item__content">
        <span>
          {{ representativeName }}
        </span>
      </div>
    </div>
    <div class="companyInfo__item workers">
      <div class="item__title">
        <span>従業員数</span>
      </div>
      <div class="item__content">
        <span>
          {{ employee_count }}
        </span>
      </div>
    </div>
    <div v-if="isEmpty(industries)" class="companyInfo__item businessContent">
      <div class="item__title">
        <span>事業内容</span>
      </div>
      <div class="item__content businessContent__list">
        <label
          v-for="(industry, index) in industries"
          :key="index"
          class="businessContent__item"
        >
          {{ industry }}
        </label>
      </div>
    </div>
    <div class="companyInfo__item location">
      <div class="item__title">
        <span>所在地</span>
      </div>
      <div class="item__content">
        <span>{{ address }} </span>
      </div>
    </div>
    <div v-if="isEmpty(company_info.capital)" class="companyInfo__item Capital">
      <div class="item__title">
        <span>資本⾦</span>
      </div>
      <div class="item__content">
        <span>
          {{ company_info.capital }}
        </span>
      </div>
    </div>
    <div v-if="isEmpty(company_info.sales)" class="companyInfo__item revenue">
      <div class="item__title">
        <span>売上⾼</span>
      </div>
      <div class="item__content">
        <span>
          {{ company_info.sales }}
        </span>
      </div>
    </div>
    <div
      v-if="isEmpty(company_info.characteristics)"
      class="companyInfo__item characteristics"
    >
      <div class="item__title">
        <span>会社の特徴</span>
      </div>
      <div class="item__content">
        <span>
          {{ company_info.characteristics }}
        </span>
      </div>
    </div>
    <div v-if="isEmpty(company_info.website)" class="companyInfo__item website">
      <div class="item__title">
        <span>URL</span>
      </div>
      <div class="item__content">
        <a :href="company_info.website">{{ company_info.website }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import * as config from '@/assets/config/selector.js'
export default {
  name: 'investor-company_info',
  props: {
    investorInfo: {
      type: Object
    }
  },
  computed: {
    company_info() {
      return this.investorInfo.company_info
    },
    address() {
      const zipcode =
        this.company_info.zipcode.length === 7
          ? `${this.company_info.zipcode.slice(
              0,
              3
            )}-${this.company_info.zipcode.slice(3)}`
          : this.company_info.zipcode
      const cityName = this.company_info.cityName
      const prefectureName = this.company_info.prefectureName
      const address = this.company_info.address
      const address2 = this.company_info.address2
      return `〒${zipcode} ${prefectureName}${cityName} ${address}${address2}`
    },
    representativeName() {
      const family_name = this.company_info.family_name
      const first_name = this.company_info.first_name
      const family_name_kana = this.company_info.family_name_kana
      const first_name_kana = this.company_info.first_name_kana
      if (family_name_kana.length || first_name_kana.length)
        return `${family_name} ${first_name}（${family_name_kana} ${first_name_kana}）`
      else return `${family_name} ${first_name}`
    },
    industries() {
      return this.company_info.business_description.map(item => {
        return config.typeOfIndustries.find(config => item === config.id).name
      })
    },
    established_year() {
      return this.company_info.established_year
        ? `${this.company_info.established_year}年`
        : ''
    },
    employee_count() {
      return config.numberOfEmployees.find(
        config => parseInt(this.company_info.employee_count) === config.id
      ).name
    }
  },
  methods: {
    isEmpty(item) {
      const type = typeof item
      switch (type) {
        case 'string':
          return !!item.trim().length
        case 'object': {
          if (Array.isArray(item)) return !!item.length
          else return Object.values(item).every(o => this.isEmpty(o))
        }
        default:
          console.error('no support type')
          return item
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.companyInfo__item {
  display: flex;
  border-bottom: 1px solid #d2d2d2;
  @include respondIn(md) {
    display: block;
    border: none;
  }
}
.item__title {
  width: 33.33%;
  background-color: #f4f4f4;
  padding: 1rem 0 1rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @include respondIn(md) {
    width: 100%;
    justify-content: center;
    padding: 1rem 0;
  }
}
.item__content {
  width: 66.66%;
  padding: 1rem;
  text-align: left;
  @include respondIn(md) {
    width: 100%;
  }
  label {
    display: inline-block;
    background-color: #f4f4f4;
    padding: 0.5rem;
    margin-right: 0.5rem;
    margin-top: 0.5rem;
    @include respondIn(md) {
      margin-bottom: 0.5rem;
    }
  }
  a {
    text-decoration: none;
    color: black;
  }
}
</style>
